var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailPreto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 19.2,
    viewBox: "0 0 24 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 24,
    height: 19.2,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.2,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M24 2.3999878C23.99615479 1.07610473 22.92388916.0038391 21.6000061-.0000061H2.3999939C1.07611084.0038391.0038452 1.07610474 0 2.3999878v14.39999389c.00384521 1.32391357 1.07611084 2.3961792 2.3999939 2.40002441h19.2000122C22.92388916 19.1961609 23.9961548 18.12389526 24 16.7999817V2.39998779zm-2.3999939 0L12 8.38799437 2.3999939 2.3999878h19.2000122zM12 10.8000122l-9.6000061-6v12h19.2000122v-12l-9.6000061 6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPreto);
export default __webpack_public_path__ + "static/media/email_preto.9613d9575c2ec568bece0070691dce12.svg";
export { ForwardRef as ReactComponent };